<template>
  <dashboard-page title="Novo tipo de requerimento">
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="card-wrapper">
            <issues-types-form-validation></issues-types-form-validation>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </dashboard-page>
</template>

<script>
import IssuesTypesFormValidation from "./IssuesTypesForm/IssuesTypesFormValidation.vue";
export default {
  name: "issues-form",
  components: {
    IssuesTypesFormValidation
  },
  data() {
    return {};
  }
};
</script>
